// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__2Xt2h","pages":"Pagination_pages__2OKjg","current":"Pagination_current__3vA1_","count":"Pagination_count__3J_u6"};